module.exports = __webpack_public_path__ + "static/media/carousel_analytics_screenshot_2.f4fc23aa.png";